import ModalsLib from '../../../../lib/modals';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/general/phone';
import Diamond from '../diamond';
import {navigate} from '../../../../utils/navigation';

export default () => {
    const {task} = useSelector(Selector);

    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/phone.png`} alt="Phone Icon" />
                </div>
                <div className="title">Phone</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Confirm your phone number to receive diamond prizes.
                </div>
                {(task.completed || task.redeemed) ? (
                    <div className="button-block completed">
                        Completed
                    </div>
                ) : (
                    <div className="button-block">
                        <div className="button" onClick={e => {
                            ModalsLib.open('phone_confirmation');
                        }}>
                            Confirm
                        </div>
                        <div className="diamonds">
                            <Diamond />
                            {task.reward}
                        </div>
                    </div>
                )}
            </div> 
        </div>
    )
}